import { render, staticRenderFns } from "./ShiftIcon.vue?vue&type=template&id=5ae808c6&"
import script from "./ShiftIcon.vue?vue&type=script&lang=js&"
export * from "./ShiftIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@nuxt/webpack/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports